/**
 * Phase 6 Plan 02 — HistoryHeader (D-132).
 *
 * Top of the HistorySection: row count + sort selector. Sort options per
 * D-132: Newest first (default), Oldest first, Worker name.
 */
import { FormattedMessage, useIntl } from "react-intl";
import type { SortKey } from "./filterLogic";

interface HistoryHeaderProps {
  shown: number;
  total: number;
  sortKey: SortKey;
   
  onSortChange: (k: SortKey) => void;
}

export function HistoryHeader({
  shown,
  total,
  sortKey,
  onSortChange,
}: HistoryHeaderProps) {
  const intl = useIntl();
  return (
    <div
      className="flex items-center justify-between gap-3 mbe-3"
      data-testid="history-header"
    >
      <h3 className="text-sm font-semibold text-on-surface-variant">
        <bdi>
          <FormattedMessage
            id="HIST_ROW_COUNT"
            values={{ shown, total }}
          />
        </bdi>
      </h3>
      <label className="flex items-center gap-2 text-xs text-on-surface-variant">
        <span className="font-semibold">
          <FormattedMessage id="HIST_SORT_LABEL" />
        </span>
        <select
          data-testid="history-sort-select"
          value={sortKey}
          onChange={(e) => onSortChange(e.target.value as SortKey)}
          className="h-8 bg-surface-raised border border-divider rounded-md ps-2 pe-2 text-sm transition-colors duration-200"
        >
          <option value="date_desc">
            {intl.formatMessage({ id: "HIST_SORT_DATE_DESC" })}
          </option>
          <option value="date_asc">
            {intl.formatMessage({ id: "HIST_SORT_DATE_ASC" })}
          </option>
          <option value="worker_alpha">
            {intl.formatMessage({ id: "HIST_SORT_WORKER" })}
          </option>
        </select>
      </label>
    </div>
  );
}
